import { patternVariantsKeys } from './interface'
import type { TPatternVariants } from './interface'

export function getTypedPatternVariants(maybePatternVariantsKey?: string | null): TPatternVariants {
  if (!maybePatternVariantsKey) return 'arch'
  const patternVariantsKey = patternVariantsKeys.find((validKey) => validKey === maybePatternVariantsKey)
  if (patternVariantsKey) {
    return patternVariantsKey
  }
  return 'arch'
}
